import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const a = s((r, t) => /* @__PURE__ */ o.jsx(
  e,
  {
    ref: t,
    ...r,
    image: (i) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M11.586 7 8.293 3.707l1.414-1.414 5 5a1 1 0 0 1 0 1.414l-5 5-1.414-1.414L11.586 9H1V7z"
          }
        )
      }
    )
  }
));
a.displayName = "ArrowRightIcon";
export {
  a as ArrowRightIcon,
  a as default
};
//# sourceMappingURL=index.js.map
